import React from 'react';

interface SpinnerProps {
  size?: string;
  borderWidth?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ size = 'w-16 h-16', borderWidth = 'border-4' }) => {
  return (
    <div className={`${size} ${borderWidth} border-border border-t-volt border-solid rounded-full animate-spin`}></div>
  );
};

export default Spinner;
